import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { getNotifications, toggleNotification, updateNotification } from './api'
import { INotification } from './typings'

const notificationAdapter = createEntityAdapter<INotification>({
  sortComparer: (a, b) =>
    a.notificationEventName.localeCompare(b.notificationEventName),
})

export const initialState = notificationAdapter.getInitialState()

const notificationSlice = createSlice({
  name: 'notificationSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNotifications.fulfilled, (state, { payload }) => {
      notificationAdapter.setAll(state, payload)
    })

    builder.addCase(toggleNotification.fulfilled, (state, { payload: id }) => {
      const notif = notificationAdapter.getSelectors().selectById(state, id)
      if (!!notif) {
        notificationAdapter.updateOne(state, {
          id,
          changes: {
            isEnabled: !notif.isEnabled,
          },
        })
      }
    })

    builder.addCase(updateNotification.fulfilled, (state, { payload }) => {
      notificationAdapter.upsertOne(state, payload)
    })
  },
})

export default notificationSlice.reducer

const notificationSelecters = notificationAdapter.getSelectors<StoreData>(
  (state) => state.notifications,
)

export const {
  selectAll: selectAllNotifications,
  selectById: selectNotificationById,
} = notificationSelecters
